<div class="bg-white rounded-lg shadow-sm p-6 border border-gray-200 h-full">
  <!-- Sync Date Info Section -->
  <div *ngIf="syncDate" class="mb-4 px-4 py-2 rounded-lg border bg-gray-50 border-gray-200">
    <div class="flex items-center space-x-2">
      <mat-icon class="text-sm text-blue-600">info</mat-icon>
      <span class="text-sm text-gray-700">
        Data retrieved from official government sources as of
        <span class="font-semibold">{{ formattedSyncDate }}</span
        >.
      </span>
    </div>
  </div>

  <div class="flex items-center mb-5">
    <div
      class="w-5 h-5 rounded-full mr-4 relative"
      [ngClass]="hasMatches ? 'bg-green-500' : 'bg-red-500'"
    >
      <div
        class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-white rounded-full"
      ></div>
    </div>
    <h2
      class="text-xl font-poppins font-semibold mb-0"
      [ngClass]="hasMatches ? 'text-green-800' : 'text-[#E53935]'"
    >
      DARPAN Registration
    </h2>
  </div>

  <div *ngIf="hasMatches && firstMatch" class="space-y-3">
    <div class="flex justify-between items-center py-3 border-b border-gray-100">
      <span class="font-poppins font-medium text-[#4B4B4B]">Registration Status</span>
      <span
        class="px-3 py-1 rounded-full text-xs font-poppins font-semibold bg-green-100 text-green-800"
      >
        REGISTERED
      </span>
    </div>

    <div class="grid grid-cols-1 gap-3">
      <div class="flex justify-between items-start py-2">
        <span class="font-poppins font-medium text-[#4B4B4B]">NGO Name</span>
        <span class="text-right max-w-[60%] font-poppins text-[#0E1116]">{{
          firstMatch.ngoName || 'N/A'
        }}</span>
      </div>

      <div class="flex justify-between items-start py-2">
        <span class="font-poppins font-medium text-[#4B4B4B]">DARPAN ID</span>
        <span class="text-right font-poppins text-[#0E1116]">{{
          firstMatch.darpanId || 'N/A'
        }}</span>
      </div>

      <div class="flex justify-between items-start py-2">
        <span class="font-poppins font-medium text-[#4B4B4B]">Registration No</span>
        <span class="text-right text-sm font-poppins text-[#0E1116]">{{
          firstMatch.registrationNo || 'N/A'
        }}</span>
      </div>

      <div class="flex justify-between items-start py-2">
        <span class="font-poppins font-medium text-[#4B4B4B]">NGO Type</span>
        <span class="text-right font-poppins text-[#0E1116]">{{
          firstMatch.ngoType || 'N/A'
        }}</span>
      </div>

      <div class="flex justify-between items-start py-2">
        <span class="font-poppins font-medium text-[#4B4B4B]">Act Name</span>
        <span class="text-right text-sm font-poppins text-[#0E1116]">{{
          firstMatch.actName || 'N/A'
        }}</span>
      </div>

      <div class="flex justify-between items-start py-2">
        <span class="font-poppins font-medium text-[#4B4B4B]">Registration Authority</span>
        <span class="text-right font-poppins text-[#0E1116]">{{
          firstMatch.regAuthority || 'N/A'
        }}</span>
      </div>

      <div class="flex justify-between items-start py-2">
        <span class="font-poppins font-medium text-[#4B4B4B]">Registration Date</span>
        <span class="text-right font-poppins text-[#0E1116]">{{
          formatDate(firstMatch.registrationDate || '')
        }}</span>
      </div>

      <div class="flex justify-between items-start py-2">
        <span class="font-poppins font-medium text-[#4B4B4B]">Address</span>
        <span class="text-right text-sm max-w-[60%] font-poppins text-[#0E1116]">{{
          firstMatch.address || 'N/A'
        }}</span>
      </div>

      <div class="flex justify-between items-start py-2">
        <span class="font-poppins font-medium text-[#4B4B4B]">State</span>
        <span class="text-right font-poppins text-[#0E1116]">{{
          firstMatch.stateName || 'N/A'
        }}</span>
      </div>

      <div class="flex justify-between items-start py-2">
        <span class="font-poppins font-medium text-[#4B4B4B]">District</span>
        <span class="text-right font-poppins text-[#0E1116]">{{
          firstMatch.districtName || 'N/A'
        }}</span>
      </div>

      <div class="flex justify-between items-start py-2">
        <span class="font-poppins font-medium text-[#4B4B4B]">Sub District</span>
        <span class="text-right font-poppins text-[#0E1116]">{{
          firstMatch.subDistrictName || 'N/A'
        }}</span>
      </div>

      <div class="flex justify-between items-start py-2">
        <span class="font-poppins font-medium text-[#4B4B4B]">Pincode</span>
        <span class="text-right font-poppins text-[#0E1116]">{{
          firstMatch.pincode || 'N/A'
        }}</span>
      </div>
    </div>

    <div *ngIf="darpanMatches.length > 1" class="mt-4 pt-3 border-t border-gray-100">
      <span class="text-sm font-poppins text-[#4B4B4B]">
        +{{ darpanMatches.length - 1 }} more match{{ darpanMatches.length > 2 ? 'es' : '' }}
      </span>
    </div>
  </div>

  <div *ngIf="!hasMatches || !firstMatch" class="space-y-3">
    <div class="flex justify-between items-center py-3 border-b border-gray-100">
      <span class="font-poppins font-medium text-[#4B4B4B]">Registration Status</span>
      <span
        class="px-3 py-1 rounded-full text-xs font-poppins font-semibold bg-red-100 text-red-800"
      >
        NOT FOUND
      </span>
    </div>
    <div class="flex justify-between items-center py-3 border-b border-gray-100">
      <span class="font-poppins font-medium text-[#4B4B4B]">Database Matches</span>
      <span class="font-poppins text-[#0E1116]">0 records</span>
    </div>
  </div>
</div>
